import React, { useContext } from "react";
import {
  AuthProvider as ROCPAuthProvider,
  AuthContext as ROCPAuthContext,
  TRefreshTokenExpiredEvent,
} from "react-oauth2-code-pkce";

const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
const REDIRECT_URL = `${window.location.origin}/auth/callback`;
const SCOPE = process.env.REACT_APP_COGNITO_SCOPE || "openid profile email";
const LOGOUT_URL =
  process.env.REACT_APP_COGNITO_LOGOUT_URL || window.location.origin;

const LOGOUT_EVENT_KEY = "httrader_supplier_portal_logout";

const authConfig = {
  decodeToken: false,
  autoLogin: false,
  clientId: CLIENT_ID || "",
  authorizationEndpoint: `${COGNITO_DOMAIN}/oauth2/authorize`,
  tokenEndpoint: `${COGNITO_DOMAIN}/oauth2/token`,
  redirectUri: REDIRECT_URL,
  scope: SCOPE,
  onRefreshTokenExpire: (event: TRefreshTokenExpiredEvent) => event.logIn(),
};

export function useAuth() {
  const context = useContext(ROCPAuthContext);

  const logOut = React.useCallback(() => {
    // 1. Broadcast logout (do not remove the key!)
    localStorage.setItem(LOGOUT_EVENT_KEY, String(Date.now()));
    // Remove app session
    localStorage.clear();
    sessionStorage.clear();

    // Remove cookies
    document.cookie.split(";").forEach((c) => {
      const eqPos = c.indexOf("=");
      const name = eqPos > -1 ? c.substr(0, eqPos) : c;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });

    // Redirect to Cognito logout using imported env variables
    window.location.href = `${COGNITO_DOMAIN}/logout?client_id=${CLIENT_ID}&logout_uri=${encodeURIComponent(
      LOGOUT_URL
    )}`;
  }, []);

  return { ...context, logOut };
}

export function AuthProvider({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <ROCPAuthProvider authConfig={authConfig}>{children}</ROCPAuthProvider>
  );
}
